export default __webpack_public_path__ + "static/media/ticket.000dd381.svg";